import { AddressDTO, ContactDTO } from 'app/modules/shared/models/contact';

export interface IContact {
    externalContactId: number;
    id?: string;
    contactType?: string;
    avatar?: string;
    title: string;
    firstname: string;
    lastname: string;
    nickname: string;
    email: string;
    company: string;
    phoneHome: string;
    phoneMobile: string;
    availabilityNotes: string;
    additionalNotes: string;
    medicalContactType: string;
    relationToUser: string;
    transitTime: 0;
    address: {
        street: string;
        streetNumber: string;
        addressSuffix: string;
        city: string;
        zip: string;
        country: 'DZ';
        region: string;
        district: string;
    };
    permissions: {
        maySendChatMessages: boolean;
        maySendAndReceivePhoneCalls: boolean;
        maySendEmails: boolean;
        isEmergencyContact: boolean;
        hasKey: boolean;

        mayEvaluateHealthData: boolean;
        mayAccessHealthData: boolean;
        mayChangeMedication: boolean;
        maySeeGeoPosition: boolean;
    };
}

// export class Contact implements IContact {
//     externalContactId: number;
//     id?: string;
//     contactType?: string;
//     avatar?: string;
//     title: string;
//     firstname: string;
//     lastname: string;
//     nickname: string;
//     email: string;
//     company: string;
//     phoneHome: string;
//     phoneMobile: string;
//     availabilityNotes: string;
//     additionalNotes: string;
//     medicalContactType: string;
//     relationToUser: string;
//     transitTime: 0;
//     address: {
//         street: string;
//         streetNumber: string;
//         addressSuffix: string;
//         city: string;
//         zip: string;
//         country: 'DZ';
//         region: string;
//         district: string;
//     };
//     permissions: {
//         maySendChatMessages: boolean;
//         maySendAndReceivePhoneCalls: boolean;
//         maySendEmails: boolean;
//         isEmergencyContact: boolean;
//         hasKey: boolean;

//         mayEvaluateHealthData: boolean;
//         mayAccessHealthData: boolean;
//         mayChangeMedication: boolean;
//         maySeeGeoPosition: boolean;
//     };
// }

// export interface Contact {
//     id?: string;
//     avatar?: string | null;
//     firstName: string;
//     nickName?: string;
//     lastName?: string;
//     email: string;
//     landline?: string;
//     mobile: string;
//     street?: string;
//     streetNo?: string;
//     zipcode?: string;
//     location?: string;
//     contactType?: string;

//     // permission
//     isMySupervisor?: boolean;
//     canSendMeChatMessages?: boolean;
//     canCallMeAndBeCalled?: boolean;
//     receiveAlertsByEmail?: boolean;
//     receiveDailyHealthInformation?: boolean;
//     canAccessMyHealthData?: boolean;
//     canIChangeMyMedication?: boolean;
//     iCanAlwaysAccessMyGeoPosition?: boolean;
//     willBeContactedInAnEmergencyAndHasAccessToEmergencyCenterData?: boolean;
//     hasKeyToFrontDoor?: boolean;
// }

export class ContactAddress extends AddressDTO {}

export class Contact extends ContactDTO {
    id?: number;
    contactType?: string;
    idType?: string;
    firstName?: string;
    lastName?: string;
    nickName?: string;

    constructor(_contact?) {
        super();

        if (_contact) {
            this.id = _contact.id;
            this.contactType = ContactType[_contact.contactType];
            this.idType = _contact.idType;
            this.firstName = _contact.firstName || '';
            this.lastName = _contact.lastName || '';
            this.nickName = _contact.nickName || '';
            this.title = _contact.title;
            this.phoneHome = _contact.phoneHome;
            this.phoneMobile = _contact.phoneMobile;
        }
    }
}

export class ContactWithPermissions extends Contact {
    // May Send And Receive Phone Calls
    maySendAndReceivePhoneCalls?: boolean;

    // May Use Drop In Calls
    mayUseDropInCalls?: boolean;
}

export enum IdType {
    USER_ID = 'USER_ID',
    EXTERNAL_CONTACT_ID = 'EXTERNAL_CONTACT_ID',
}

export enum ContactType {
    // CareTaker = 'My supervisor',
    // External = 'External contact',
    // Internal = 'Alpha contact',
    // Patient = 'My supervisor',
    // CARE_ASSISTANT = 'My supervisor',
    // EXTERNAL_CONTACT = 'External contact',
    // INTERNAL_CONTACT = 'Alpha contact',
    // PATIENT = 'My supervisor',
    CARE_ASSISTANT = 'CARE-ASSISTANT',
    EXTERNAL_CONTACT = 'EXTERNAL-CONTACT',
    INTERNAL_CONTACT = 'INTERNAL-CONTACT',
    PATIENT = 'PATIENT',
}
